/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import DocsSlider from 'components/ui/DocsSlider'
import DocItem from 'components/ui/DocItem'
// import Btn from 'components/ui/Btn'
// import ListServices, { ServiceItem } from 'components/ui/ListServices'
import ScrollControl from 'components/ui/ScrollControl'

/*Images*/
import Modal from "components/Modal";
import { getValue } from 'helpers/Objects';
// import ScrollControl from '../ScrollControl';

/*CORES*/
import AppCore from 'cores/AppCore'
import {Helpers} from "api";

const ContDocs = (props = {}) => {
    const {
        id,
        user = {},
        value = {}
    } = props

    // const usersDiploms = getValue(user, "diploms", [])
    // const usersCertificates = getValue(user, "certificates", [])

    const valuesDiploms = getValue(value, "diploms", [])
    const valuesCertificates = getValue(value, "certificates", [])

    // const list = [
    //     ...usersDiploms.filter(item => valuesDiploms.includes(item.id)),
    //     ...usersCertificates.filter(item => valuesCertificates.includes(item.id))
    // ]

    const list = [
        ...valuesDiploms,
        ...valuesCertificates
    ]

    const [open, setOpen] = React.useState( false )
    const [link, setLink] = React.useState( "" )

    const openModal = (link) => {
        setLink( link )
        setOpen( true )
    }

    const closeModal = () => {
        setOpen( false )
        setLink( "" )
    }

    return(
        <>
            {list.length > 0 &&
            <Cont id={`block-${id}`} className="cont-docs">
                <h2>
                    { AppCore.Interfaces.t( "DoctorLanding.Ui.ContDocs.Index.Title" ) }
                </h2>

                <DocsSlider>
                    {list.map(item => (<DocItem
                        key={item}
                        link={Helpers.GetImage(item)}
                        image={
                            <Img src={Helpers.GetImage(item, "253_251")} externals div/>
                        }
                        onClick={openModal}
                    />))}
                </DocsSlider>

                <Modal
                    isOpen={open}
                    onRequestClose={closeModal}
                >
                    <Img src={link} externals/>
                </Modal>
            </Cont>
            }
        </>

    )
}

export default ContDocs